import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, NavX, QsX, ReqX, ZArray } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XScroll, XText } from "IZOX/_X";
import { PageFlipper, QForm } from "IZOX/BLOCKS/Libs";
import { QFCheckBox, QFDate, QFDropdown, QFText } from "IZOX/BLOCKS/Libs/QForm/_gears";
import _ from "lodash";
import NewPolicy from "./_gears/NewPolicy";
import QUICKUI from "shared/QUICKUI";
import ViewPolicy from "./_gears/ViewPolicy";
import PolicyRow from "shared/PolicyRow";
import UploadDocs from "./_gears/UploadDocs";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import VarList from "shared/VarList";
import RenewPolicy from "./_gears/RenewPolicy";
import PDCContainer from "../shared/PDCContainer/PDCContainer";

/**
 * @augments {Component<Props, State>}
 */
class PDCAllPoliciesM extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      docs: [],
      selected: [],
      tab: "Total",
      page: 0,
      pageSize: 5,
      search: false,
      searchForm: {}
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetNationalityList();
      let res = this.ParseQS();
      if(res){
        this.GetPolicies();
      }
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PDCAllPoliciesM.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  ParseQS = () => {
    let {location} = this.props;
    let {search} = location ?? {};
    let params = QsX.Parse(search);
    let {status} = params ?? {};
    if(status){
      this._toTab(status);
      return false;
    }
    return true;
    
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  GetNationalityList = async () => {
    let docs = await VarList.GetList("Nationality");
    this.setState({
      nationalities: docs
    });
  }

  _Reload = () => {
    let {search} = this.state;
    if(search){
      this._toSearch();
    }else{
      this.GetPolicies();
    }
  }

  _onUpload = (_id) => {
    this._toUpload([_id]);
  }

  _onDownload = async (_id) => {
    let res = await ReqX.SendBE("/Web/DCustomer/GenerateReport");
    let {Success, payload} = res;
    if(Success){
      NavX.NewWindow("https://mutual-service.vtl-lab.com" + payload?.url);
    }
  }

  _onCheck = (_id) => {
    let {selected, docs} = this.state;
    if(selected.includes(_id)){
      selected = _.filter(selected, o => o !== _id);
    }else{
      selected.push(_id);
    }

    let selectedAllForm = {
      selectAll: false
    };
    if(selected.length === docs.length){
      selectedAllForm = {
        selectAll: true
      };
    }
    this.setState({
      selected: selected,
      selectedAllForm: selectedAllForm
    });
  }

  GetPolicies = async () => {
    let {tab, page, pageSize} = this.state;
    let res = await ReqX.SendBE("/Web/DCustomer/GetPolicies", {
      status: tab === "Total" ? undefined : tab,
      page: page,
      pageSize: pageSize
    });
    let {Success, payload} = res;
    if(Success){
      let {docs, count} = payload;
      this.setState({
        docs: docs,
        count: count
      });
    }
  }

  _onPageSizeChange = (pageSize) => {
    this.setState({
      pageSize: pageSize
    }, () => {
      this._Reload();
    });
  }

  _onPageChange = (page) => {
    this.setState({
      page: page
    }, () => {
      this._Reload();
    });
  }

  onMountQForm = (callbacks) => {
    this.MountQForm = callbacks;
  }

  onFormChange = (formValue) => {
    this.setState({
      searchForm: formValue
    });
  }

  _toNewPolicy = () => {
    GFunc.Backdrop(() => {
      return (
        <NewPolicy refreshFunc={this._Reload}/>
      );
    }, {}, false);
  }

  _toClearSearch = () => {
    this.setState({
      searchForm: {},
      search: false
    }, () => {
      this.MountQForm?.Clear();
      this._Reload();
    });
  }

  _toSearch = () => {
    this.setState({
      page: 0
    }, () => {
      this._toSearchSubmit();
    });
  }

  _toSearchSubmit = async () => {
    let {tab, page, pageSize, searchForm} = this.state;
    let res = await ReqX.SendBE("/Web/DCustomer/SearchPolicies", {
      searchForm, 
      status: tab === "Total" ? undefined : tab,
      page, pageSize
    });
    let {Success, payload} = res;
    if(Success){
      let {docs, count} = payload;
      this.setState({
        docs: docs,
        count: count,
        search: true
      });
    }
  }

  _toUpload = (selected, isReceipt = false) => {
    GFunc.Backdrop(() => {
      return (
        <UploadDocs selected={selected} isReceipt={isReceipt}/>
      );
    }, {}, false);
  }

  _toReceipt = (selected) => {
    this._toUpload(selected, true);
  }

  _toRenew = (selected) => {
    selected = ZArray.Ensure(selected);
    GFunc.Backdrop(() => {
      return (
        <RenewPolicy selected={selected}/>
      );
    }, {}, false);
  }

  _toToggleCheckAll = (selectedAllForm) => {
    let {docs} = this.state;
    let {selectAll} = selectedAllForm;
    let _selected = selectAll ? _.map(docs, o => o._id) : [];
    this.setState({
      selected: _selected,
      selectedAllForm: selectedAllForm
    });
  }

  _toTab = (tab) => {
    console.log(tab);
    this.setState({
      tab: tab,
      page: 0,
      selected: [],
      selectedAllForm: {
        selectAll: false
      }
    }, () => {
      this.GetPolicies();
    });
  }

  _toPopupDetails = async (_id) => {
    GFunc.Backdrop(() => {
      return (
        <ViewPolicy docID={_id}/>
      );
    }, {}, false);
  }

  renderHeader(){
    return (
      <HStack mB={12}>
        <XText bold color={ColorX.CSS("Leaf")} fontSize={16}>
          {LocaleX.Parse({
            EN: "All Policies",
            TC: "所有保單"
          })}
        </XText>
        <Spacer/>
        <XButton onPress={this._toNewPolicy} pH={30} round={50}
            bgColor={ColorX.CSS("Axit")}
            color={ColorX.CSS("pureWhite")}
            padding={6}>
          <HStack>
            <XText bold fontSize={14}>
              {LocaleX.Parse({
                EN: "Add new policy",
                TC: "新增保單"
              })}
            </XText>
          </HStack>
        </XButton>
      </HStack>
    );
  }

  renderTextField(name, label, readOnly = false){
    let {userDoc} = this.state;
    let value = Accessor.Get(userDoc, name);
    return (
      <VStack fullWidth>
        <HStack HAlign="[" spacing={4}>
          <XText fontSize={12} color={ColorX.CSS("Stone")}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <QFText name={name} placeholder={LocaleX.Parse({
          EN: "Search ",
          TC: "搜尋 "
        }) + LocaleX.Parse(label).toLowerCase()} disabled={readOnly}
          defaultValue={value}
          p={12}
          focus_bColor={ColorX.CSS("Axit")}
          bColor={ColorX.CSS("Gray5")}/>
      </VStack>
    );
  }

  renderSearchForm(){
    let {search, searchForm, nationalities} = this.state;
    return (
      <QForm fullWidth p={12} bgColor={ColorX.CSS("pureWhite")}
        value={searchForm} onMounted={this.onMountQForm}
        spacing={24} onChange={this.onFormChange}>
        {this.renderTextField("helperName", 
        {
          EN: "Helper's name",
          TC: "助理名稱"
        })}
        {this.renderTextField("policyNo", 
          {
            EN: "Policy number / Insurance certificate No.",
            TC: "保單號碼 / 保險憑證號碼"
          })}
        {this.renderTextField("helperPassport", 
        {
          EN: "Helper's passport number / ID",
          TC: "助理的護照號碼 / 身分證號碼"
        })}
        <VStack fullWidth>
          <HStack HAlign="[" spacing={4}>
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "Nationality",
                TC: "國籍"
              })}
            </XText>
          </HStack>
          <QFDropdown name={"nationality"}
            options={nationalities}
            placeholder={LocaleX.Parse({
              EN: "Select Nationality",
              TC: "選擇國籍"
            })}
            valAccessor="_id"
            capAccessor="name"
            p={12}
            bW={1}
            height={44}
            focus_bColor={ColorX.CSS("Axit")}
            bColor={ColorX.CSS("Gray5")}
            allowSearch/>
        </VStack>
        <VStack fullWidth>
          <HStack HAlign="[" spacing={4}>
            <XText fontSize={12} color={ColorX.CSS("Stone")}>
              {LocaleX.Parse({
                EN: "Effective date",
                TC: "有效日期"
              })}
            </XText>
          </HStack>
          <QFDate name={"startAt"}
            p={12}
            bW={1}
            height={44}
            focus_bColor={ColorX.CSS("Axit")}
            bColor={ColorX.CSS("Gray5")}
            placeholder={LocaleX.Parse({
              EN: "Search effective date",
              TC: "搜尋有效日期"
            })}/>
        </VStack>
        <HStack>
          <XButton onPress={this._toClearSearch} fullWidth
            color={ColorX.CSS("Axit")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Reset",
                  TC: "重置"
                })}
              </XText>
            </HStack>
          </XButton>
          <XButton onPress={this._toSearch} padding={0} pV={5} fullWidth
            color={ColorX.CSS(search ? "pureWhite" : "Axit")} 
            bgColor={ColorX.CSS(search ? "Axit" : "pureWhite")} 
            style={{borderColor: ColorX.CSS("Axit")}}
            bW={1} round={50}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Search",
                  TC: "搜尋"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>
      </QForm>
    );
  }

  renderBulkBtn(label, func){
    let {selected} = this.state;
    return (
    <XButton onPress={func} fitWidthToContent padding={8}
      disabled={!selected || selected?.length === 0}
        pH={15} round={50} bW={1}
        bColor={ColorX.CSS("Axit")}
        color={ColorX.CSS("Axit")}>
        <HStack>
          <XText fontSize={12} noWrap>
            {LocaleX.Parse({
              EN: `${label?.EN ?? label} (${selected?.length})`,
              TC: `${label?.TC ?? label} (${selected?.length})`
            })}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderPolicyHeader(){
    let { selected, tab, count } = this.state;
    return (
      <VStack fullWidth spacing={20} HAlign="[">
        <XText bold color={ColorX.CSS("Leaf")} fontSize={14}>
          {LocaleX.Parse({
            EN: `List policies (${count ?? 0})`,
            TC: `保單清單 (${count ?? 0})`
          })}
        </XText>
        <Spacer/>
        <XScroll fullWidth>
          <HStack fitWidthToContent spacing={10} HAlign="[">
            {this.renderBulkBtn({
              EN: "Upload documents",
              TC: "上傳文件"
            }, () => this._toUpload(selected))}
            {this.renderBulkBtn({
              EN: "Upload receipts",
              TC: "上傳收據"
            }, () => this._toUpload(selected, true))}
            {tab === "ExpirySoon" &&
              this.renderBulkBtn({
                EN: "Batch Renew",
                TC: "批量續訂"
              }, () => this._toRenew(selected))}
          </HStack>
        </XScroll>
      </VStack>
    );
  }

  renderTabBtn(_tab, text, extraStyle, idx){
    let {tab} = this.state;
    let isTab = tab === _tab;
    return (
      <XButton color={ColorX.CSS(isTab? "pureWhite" : "Gray4")}
        bgColor={ColorX.CSS(isTab ? "Axit" : "pureWhite")}
        fitWidthToContent zIndex={isTab ? 15 : 10 - idx}
        mL={idx === 0 ? 0 : -10} mT={10} shadow minWidth={50}
        padding={10} pH={15} round={[5, 5, 0, 0]}
        onPress={() => this._toTab(_tab)}
        style={extraStyle}>
        <HStack>
          <XText fontSize={14} noWrap>
            {LocaleX.Parse(text)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderPolicyTabs(){
    let {selectedAllForm} = this.state;
    return (
      <VStack fullWidth>
        <QForm fullWidth onChange={this._toToggleCheckAll} value={selectedAllForm}>
          <HStack spacing={10} HAlign="]" pV={10}>
            <QFCheckBox name="selectAll"
              bColor={ColorX.CSS("pureWhite")} size={16}
              bgColor={ColorX.CSS("pureWhite")} color={ColorX.CSS("Axit")} />
            <XText color={ColorX.CSS("Axit")} fontSize={14}>
              {LocaleX.Parse({
                EN: "Check all",
                TC: "勾選全部"
              })}
            </XText>
          </HStack>
        </QForm>
        <XScroll fullWidth>
          <HStack fitWidthToContent HAlign="[">
            {this.renderTabBtn("Total", {EN: "All", TC: "全部"}, {}, 0)}
            {this.renderTabBtn("Pending", {EN: "Pending", TC: "處理中"}, {}, 1)}
            {this.renderTabBtn("Active", {EN: "Active", TC: "生效中"}, {}, 2)}
            {this.renderTabBtn("ExpirySoon", {EN: "Expiry Soon", TC: "即將過期"}, {}, 3)}
            {this.renderTabBtn("Expired", {EN: "Expired", TC: "已過期"}, {}, 4)}
            {this.renderTabBtn("Canceled", {EN: "Canceled", TC: "已取消"}, {}, 5)}
            {this.renderTabBtn("Renewed", {EN: "Renewal", TC: "已更新"}, {}, 6)}
          </HStack>
        </XScroll>
      </VStack>
    );
  }

  renderPolicyDoc(doc, idx){
    let {selected, tab} = this.state;
    let {_id} = doc;
    let isRenew = tab === "ExpirySoon";

    return (
      <PolicyRow policyDoc={doc} key={idx} 
        checked={selected.includes(_id)}
        onCheck={() => this._onCheck(_id)}
        onDownload={() => this._onDownload(_id)}
        onUpload={() => this._onUpload(_id)}
        onReceipt={() => this._toReceipt(_id)}
        onViewDetailPress={() => this._toPopupDetails(_id)}
        onRenew={() => this._toRenew(_id)}
        isRenew={isRenew}/>
    );
  }

  renderPolicyList(){
    let {docs, page, pageSize, count} = this.state;
    if(docs.length === 0){
      return QUICKUI.NoDocs({
        EN: "There is no policies.",
        TC: "沒有任何保單。"
      });
    }
    
    return (
      <VStack fullWidth>
        {_.map(docs, (o, i) => {
          return this.renderPolicyDoc(o, i);
        })}
        <PageFlipper totalDocs={count} 
          page={page}
          pageSize={pageSize}
          onPageSizeChange={this._onPageSizeChange}
          onPageChange={this._onPageChange}
          popupPosition="top" 
          mainColor={ColorX.CSS("Axit")} 
          fontSize={12}
          />
      </VStack>
    );
  }

  renderPolicies(){
    return (
      <VStack fullWidth mT={20}>
        {this.renderPolicyHeader()}
        {this.renderPolicyTabs()}
        {this.renderPolicyList()}
      </VStack>
    );
  }

  render(){
    return (
      <PDCContainer>
        <VStack bgColor={ColorX.CSS("NotQuiteWhite")} fullWidth
          p={16}>
          {this.renderHeader()}
          {this.renderSearchForm()}
          {this.renderPolicies()}
        </VStack>
      </PDCContainer>
    );
  }

}

export default withRouter(observer(PDCAllPoliciesM));
